function addCreditCardInputMask(elements) {
  elements.inputmask('aaaa-aaaa-aaaa-aaaa', {
    placeholder: ' ',
  });
}

function init() {
  addCreditCardInputMask($('[data-gift-card-token-input]'));
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/gift_cards/redeem.js